import { delay, http, HttpResponse } from 'msw';

export const hideCandidateMutationMocked = http.post<{ chatId: string }, { es_person_id: string; status: 'HIDDEN' }>(
  '/api/campaigns/:chatId/candidates/',
  async ({ request, params }) => {
    const data = await request.clone().json();

    await delay(1200);

    return HttpResponse.json({ campaign_id: params.chatId, es_person_id: data.es_person_id, status: data.status });
  },
);
